import * as types from "@/store/mutation-types";
import { DefineMutations } from "vuex-type-helper";
import { QuickPayState, QuickPayMutations, StateKeys } from "./types";
import { GenericSetState, GenericSetStates } from "@/store/helpers";

export const mutations: DefineMutations<QuickPayMutations, QuickPayState> = {
  [types.SET_STATE]: GenericSetState<QuickPayState, StateKeys>(),
  [types.SET_STATES]: GenericSetStates<QuickPayState>()
};
